import { render, staticRenderFns } from "./DataTableDateColumn.vue?vue&type=template&id=0170e1bc&"
import script from "./DataTableDateColumn.vue?vue&type=script&lang=js&"
export * from "./DataTableDateColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports